import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { useLang, WHATSAPP_URL, PHONE_DISPLAY, EMAIL } from "../i18n";
import { Logo, WhatsAppIcon } from "./Logo";

const RIGHTS = {
  it: "© 2026 GWD – Grafica Web Design, marchio del gruppo Pixaweb sagl. Tutti i diritti riservati.",
  de: "© 2026 GWD – Grafica Web Design, eine Marke der Pixaweb sagl. Alle Rechte vorbehalten.",
  fr: "© 2026 GWD – Grafica Web Design, marque du groupe Pixaweb sagl. Tous droits réservés.",
  en: "© 2026 GWD – Grafica Web Design, a brand of Pixaweb sagl. All rights reserved.",
};

export const Footer = () => {
  const { t, lang } = useLang();

  return (
    <footer data-testid="footer" className="border-t border-slate-800/70 bg-[#05080D] py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">{t.footer.tag}</p>
          </div>
          <div>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.28em] text-slate-500">{t.footer.contact}</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="inline-flex items-center gap-2.5 text-slate-300 transition-colors hover:text-emerald-300">
                  <Mail className="h-4 w-4 text-emerald-400" /> {EMAIL}
                </a>
              </li>
              <li>
                <a href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`} data-testid="footer-phone" className="inline-flex items-center gap-2.5 text-slate-300 transition-colors hover:text-emerald-300">
                  <Phone className="h-4 w-4 text-emerald-400" /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-2.5 text-slate-300 transition-colors hover:text-emerald-300">
                  <WhatsAppIcon className="h-4 w-4 text-emerald-400" /> WhatsApp
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono2 text-[10px] uppercase tracking-[0.28em] text-slate-500">{t.footer.langs}</p>
            <p className="mt-4 text-sm text-slate-300">Italiano · Deutsch · Français · English</p>
            <p className="mt-2 text-xs text-slate-600">Lugano, Ticino — Svizzera</p>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-slate-800/60 pt-7 sm:flex-row">
          <p className="text-xs text-slate-600">{RIGHTS[lang] || RIGHTS.it}</p>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="text-xs text-slate-500 underline-offset-4 transition-colors hover:text-emerald-300 hover:underline"
          >
            {t.footer.legal}
          </Link>
        </div>
      </div>
    </footer>
  );
};
